import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface MarqueeProps {
    children: ReactNode
    className?: string
    duration?: number
    reverse?: boolean
}

// Seamless horizontal loop: the content is rendered twice and the track slides by exactly one copy.
export const Marquee: FC<MarqueeProps> = ({ children, className, duration = 40, reverse = false }): ReactNode => {
    const style = {
        '--marquee-duration': `${duration}s`,
        animationDirection: reverse ? 'reverse' : 'normal'
    } as CSSProperties

    return (
        <div className={cn('relative flex overflow-hidden', className)}>
            <div className='marquee-track' style={style}>
                <div className='flex shrink-0 items-center'>
                    {children}
                </div>

                <div aria-hidden='true' className='flex shrink-0 items-center'>
                    {children}
                </div>
            </div>
        </div>
    )
}
